import styled from 'styled-components';
import { THEME } from '../../../../themes';
import { Scrollbar } from '../../../../themes/scrollbar';
import { hexToRgbA } from '../../../../utils/colors';

export const ScrollContainer = styled.div`
  ${Scrollbar};
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  max-width: ${THEME.BREAKPOINTS.WIDTH.LAPTOP_MIN}px;
  display: flex;
  flex-direction: column;
  padding: ${THEME.SPACING.LARGE} 0 ${THEME.SPACING.BASE};
  align-self: center;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${THEME.SPACING.MEDIUM};
  min-height: 60px;
`;

export const PageHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.TINO};
  flex: 1;
  min-height: 60px;
`;

export const PageHeaderRight = styled.div`
  display: flex;
  gap: ${THEME.SPACING.BASE};
  align-items: flex-end;
  flex-shrink: 0;
`;

export const UserPickersSection = styled.div`
  display: flex;
  gap: ${THEME.SPACING.LOOSE};
  align-items: flex-end;
`;

export const UserPickerAvatars = styled.div`
  display: flex;
  gap: ${THEME.SPACING.TINO};
`;

export const VerticalDivider = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
`;

export const PageBody = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${THEME.SPACING.BASE};
`;

export const StatisticSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.BASE};
  max-width: 644px;
`;

export const StatisticsCardsMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.BASE};
  padding: ${THEME.SPACING.MEDIUM};
  padding-right: ${THEME.SPACING.TINO};
  border-radius: ${THEME.RADIUS.CURVY};
  background-color: ${THEME.COLORS.PURE_WHITE};
  height: 256px;
`;

export const StatisticsCardsLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${THEME.SPACING.TINY};
`;

export const StatisticsCardsContainer = styled.div`
  display: flex;
  gap: ${THEME.SPACING.BASE};
`;

export const StatisticCard = styled.div`
  width: 192px;
  height: 176px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${THEME.COLORS.PURE_WHITE};
  padding: ${THEME.SPACING.BASE};
  border-radius: ${THEME.RADIUS.CURVY};
  border: solid 1px ${hexToRgbA(THEME.COLORS.PRIMARY_DARK, THEME.OPACITY.GHOST)};
  gap: ${THEME.SPACING.TINY};
`;

export const RealizationMetricsContainer = styled.div`
  display: flex;
  justify-content: space-betwen;
  gap: ${THEME.SPACING.BASE};
`;

export const RealizationMetricCard = styled.div`
  position: relative;
  flex: 50%;
  display: flex;
  flex-direction: column;
  height: 176px;
  background-color: ${THEME.COLORS.PURE_WHITE};
  border-radius: ${THEME.RADIUS.CURVY};
  padding: ${THEME.SPACING.BASE} ${THEME.SPACING.MEDIUM} ${THEME.SPACING.BASE} ${THEME.SPACING.MEDIUM};
  gap: ${THEME.SPACING.BASE};
`;

export const AssistantContainer = styled.div`
  border-radius: ${THEME.RADIUS.CURVY};
  background-color: ${THEME.COLORS.PURE_WHITE};
  padding: ${THEME.SPACING.MEDIUM};
  padding-bottom: ${THEME.SPACING.TINO};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
  height: 448px;
`;

export const AssistantHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${THEME.SPACING.TINY};
`;

export const AssistantBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${THEME.SPACING.BASE};
  flex-grow: 1;
  justify-content: center;
`;

export const PositionPerformanceFunnelContainer = styled.div`
  margin-top: ${THEME.SPACING.BASE};
`;

export const FunnelContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${THEME.COLORS.PURE_WHITE};
  border-radius: ${THEME.RADIUS.CURVY};
  width: fit-content;
  overflow: hidden;
  gap: ${THEME.SPACING.BASE};   
  border: ${THEME.SPACING.TINY} solid ${THEME.COLORS.PURE_WHITE};
`;

export const FunnelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: ${THEME.SPACING.BASE};
  padding-right: ${THEME.SPACING.BASE};
  padding-top: ${THEME.SPACING.TINY};
  gap: ${THEME.SPACING.BASE};
  align-items: center;
`;

export const FunnelBars = styled.div`
  display: flex;
  gap: ${THEME.SPACING.BASE};
`;
